import { BehaviorSubject } from "rxjs";
import httpClient from "../utilis/jwtRequest";

const accessToken = new BehaviorSubject("");
const ACCESS_TOKEN_KEY = "accessToken";

const login = (data) => {
  return httpClient.post("account/auth", data).then((res) => {
    accessToken.next(res.data.token);
    localStorage.setItem(ACCESS_TOKEN_KEY, res.data.token);
  });
};

function getCurrentUser() {
  return httpClient.get("users/current").then((res) => {
    const user = res.data;
    if (user.isCoworker) {
      return httpClient
        .get(`coworkers/${user.id}`)
    }
    return res;
  });
}

const logout = () => {
  accessToken.next("");
  localStorage.removeItem(ACCESS_TOKEN_KEY);
};

const setAccessTokenFromLocalStorage = () => {
  const tokenFromLocalStorage = localStorage.getItem(ACCESS_TOKEN_KEY);
  if (tokenFromLocalStorage) {
    setAccessToken(tokenFromLocalStorage);
  }
};

const setAccessToken = (token) => {
  accessToken.next(token);
};

export const authService = {
  login,
  logout,
  setAccessTokenFromLocalStorage,
  currentToken: accessToken.asObservable(),
  get tokenValue() {
    return accessToken.value;
  },
  getCurrentUser,
};
